import { IDdocIndexerResponse } from './get-ddocs-by-portal-address';

export interface GetDdocsByIDResponse {
  latest: IDdocIndexerResponse;
  potential: IDdocIndexerResponse[];
}

export const getDdocDataById = async (
  ddocId: string,
  portalAddress: string,
  bypassCache = false
): Promise<IDdocIndexerResponse> => {
  if (!ddocId || !portalAddress) {
    throw new Error('ddocId and portalAddress are required parameters');
  }

  const baseUrl = process.env.NEXT_PUBLIC_INDEXER_API;
  if (!baseUrl) {
    throw new Error(
      'NEXT_PUBLIC_INDEXER_API environment variable is not defined'
    );
  }

  try {
    const url = `${baseUrl}/ddoc/${ddocId}`;
    if (bypassCache) url + '?refresh=true';
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        contract: portalAddress,
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch ddoc: ${res.status} ${res.statusText}`);
    }

    const jsonResponse = (await res.json()) as GetDdocsByIDResponse;

    return jsonResponse.latest;
  } catch (error) {
    throw error instanceof Error
      ? error
      : new Error('An unexpected error occurred while fetching ddoc data');
  }
};

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitForDeletedDdocDataById = async (
  ddocId: string,
  portalAddress: string
) => {
  const maxTries = 5;
  for (let i = 0; i < maxTries; i++) {
    const response = await getDdocDataById(ddocId, portalAddress, true);
    if (response.isDeleted) return response;
    await sleep(1000);
  }
  return null;
};
